export const GATSBY_GOOGLE_ANALYTICS_COOKIE_NAME =
  'gatsby-plugin-google-analytics-gdpr-cookies'
export const GATSBY_GOOGLE_TAG_MANAGER_COOKIE_NAME =
  'gatsby-plugin-google-tagmanager-gdpr-cookies'

// States requiring opt-in cookie consent (CCPA and similar regulations)
export const COOKIE_CONSENT_OPT_IN_STATES = new Set(['CA', 'FL'])
